import { skipToken } from '@reduxjs/toolkit/query/react';
import { useGetEmployeePhotoQuery } from '@store/api';

interface EmployeePhotoState {
  src: string | null;
  isLoading: boolean;
}

/**
 * Thin store-composition wrapper (feature 107): reads the employee photo from the store's
 * `mediaService` instead of issuing a direct `fetch`. The store caches per employee id and
 * records misses as a resolved `null`, preserving the previous in-session behavior.
 */
export function useEmployeePhoto(employeeId: string | undefined): EmployeePhotoState {
  const { data, isLoading, isFetching } = useGetEmployeePhotoQuery(
    employeeId ? employeeId : skipToken
  );

  return {
    src: data?.dataUrl ?? null,
    isLoading: !!employeeId && (isLoading || isFetching),
  };
}
